import type { ReactNode } from "react";
import { cn, titleCase } from "@/lib/utils";
import { useTranslation } from "react-i18next";

export function Badge({ children, className, title, tone = "grey" }: { children: ReactNode; className?: string; title?: string; tone?: "grey" | "dark" | "blue" | "red" | "green" | "orange" | "accent" }) {
  const tones = {
    grey: "bg-fill text-ink",
    dark: "bg-ink text-surface",
    blue: "bg-primary-soft text-ink",
    red: "bg-danger-soft text-danger",
    green: "bg-success-soft text-success",
    orange: "bg-budget-soft text-budget",
    accent: "bg-accent-soft text-ink",
  };
  return (
    <span title={title} className={cn("inline-flex items-center gap-1 rounded-full px-2.5 py-0.5 text-[11px] font-semibold whitespace-nowrap", tones[tone], className)}>
      {children}
    </span>
  );
}

/** Status rangi (pill fon, menyudagi nuqta) */
export const STATUS_BG: Record<string, string> = {
  new: "bg-status-new",
  contacted: "bg-status-contacted",
  qualified: "bg-status-qualified",
  docs: "bg-status-docs",
  submitted: "bg-status-submitted",
  background_check: "bg-status-background_check",
  orientation: "bg-status-orientation",
  hired: "bg-status-hired",
  rejected: "bg-status-rejected",
  not_interested: "bg-status-not_interested",
  quit: "bg-status-quit",
  open: "bg-status-hired",
  filled: "bg-status-docs",
  closed: "bg-status-docs",
  active: "bg-status-hired",
  paused: "bg-status-submitted",
  stopped: "bg-status-rejected",
  pending: "bg-status-submitted",
  approved: "bg-status-hired",
  draft: "bg-status-docs",
  paid: "bg-status-hired",
  in_review: "bg-status-submitted",
  accepted: "bg-status-hired",
  // Truck: bo'sh (driver kerak) -- yashil, band -- ko'k, ta'mirda -- sariq, ishlatilmaydi -- kulrang
  available: "bg-status-hired",
  assigned: "bg-status-contacted",
  in_shop: "bg-status-submitted",
  inactive: "bg-status-docs",
};

/** Bosqich lentasi va nuqtalari uchun to'q ranglar (grafik, pipeline lentasi) */
export const STAGE_BG: Record<string, string> = {
  new: "bg-stage-new",
  contacted: "bg-stage-contacted",
  qualified: "bg-stage-qualified",
  docs: "bg-stage-docs",
  submitted: "bg-stage-submitted",
  background_check: "bg-stage-background_check",
  orientation: "bg-stage-orientation",
  hired: "bg-stage-hired",
};

/** Status chipi: yumshoq fon, to'q matn */
export function StatusPill({ status, label, className }: { status: string; label?: string; className?: string }) {
  const { t } = useTranslation();
  const text = label ?? t(`status.${status}`, { defaultValue: titleCase(status) });
  return (
    <span className={cn("inline-flex items-center rounded-full px-2.5 py-0.5 text-[11px] font-semibold whitespace-nowrap text-ink", STATUS_BG[status] ?? "bg-fill", className)}>
      {text}
    </span>
  );
}

/** Raqamli belgi (menyu, bildirishnoma): qizil -- kechikkan/muhim, kulrang -- oddiy son */
export function CountBadge({ count, tone = "grey", className }: { count: number; tone?: "grey" | "red"; className?: string }) {
  if (!count) return null;
  return (
    <span className={cn("tabular ml-auto inline-flex min-w-[20px] items-center justify-center rounded-full px-1.5 text-[11px] font-bold", tone === "red" ? "bg-danger text-white" : "bg-ink text-surface", className)}>
      {count > 99 ? "99+" : count}
    </span>
  );
}
